import { useLang } from "hooks/useLang";
import React from "react";
import { FaWhatsapp } from "react-icons/fa";
import Link from "next/link"


interface PulseWhatsappProps {
  size?: number;
  color?: string;
  className?: string;
}

const PulseWhatsapp: React.FC<PulseWhatsappProps> = ({
  size = 50,
  color = "#25D366",
  className = "",
}) => {

  
  return (
    <Link href={"https://api.whatsapp.com/send?phone=966530053321"}
      target="_blank"
      rel="noopener noreferrer" className={`relative inline-flex ${className} mx-7 cursor-pointer`}>
      {/* Pulse effect */}
      <span
        className="absolute inset-0 flex items-center justify-center"
        style={{
          height: size,
          width: size,
        }}
      >
        <span
          className="absolute rounded-full hover:animate-ping opacity-50"
          style={{
            height: size,
            width: size,
            backgroundColor: color,
          }}
        />
      </span>

      {/* Solid icon */}
      <span
        className="relative flex items-center justify-center rounded-full"
        style={{
          height: size,
          width: size,
          backgroundColor: color,
        }}
      >
        <FaWhatsapp color="white" size={size * 0.6} />
      </span>
    </Link>
  );
};

export default PulseWhatsapp;
